import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { archiveFaxes, markFaxesAsRead } from 'api/Fax';

import { ia } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';
import Button from 'components/shared/Buttons/Button';

import AssignPatientModal from '../../components/AssignPatientModal';
import AssignProvidersModal from '../../components/AssignProvidersModal';

const ButtonActions = ({ selectedRows = [] }) => {
  selectedRows = selectedRows.map((it) => it?.data);

  const [assignPatientModalVisible, setAssignPatientModalVisible] = useState(false);
  const [assignProvidersModalVisible, setAssignProvidersModalVisible] = useState(false);

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const onFaxesArchive = () => {
    archiveFaxes(
      navigate,
      selectedRows.map((fax) => fax.id)
    ).then(() => {
      queryClient.refetchQueries(['archivedFaxes']);
      queryClient.invalidateQueries(['inboundFaxes']);
    });
  };

  const handleMarkAsRead = async (faxId = null) => {
    await markFaxesAsRead(
      navigate,
      ia(faxId) ? faxId : selectedRows?.map((fax) => fax.id),
      onSuccess
    );

    function onSuccess() {
      queryClient.invalidateQueries(['inboundFaxes']);
      queryClient.invalidateQueries(['unreadFaxes']);

      showAlert({ message: 'Faxes marked as read', color: 'success' });
    }
  };

  if (!ia(selectedRows)) return null;

  return (
    <>
      <div className="flex items-center gap-2 opacity-100 transition-opacity">
        <Button text="Mark as read" onClick={handleMarkAsRead} className="h-[34px] py-1 text-sm" />
        <Button
          text="Assign Patient"
          color="success"
          className="h-[34px] py-1 text-sm"
          onClick={() => setAssignPatientModalVisible(true)}
        />
        <Button
          text="Assign Providers"
          color="success"
          className="h-[34px] py-1 text-sm"
          onClick={() => setAssignProvidersModalVisible(true)}
        />
        <Button
          text="Archive"
          color="neutral"
          className="h-[34px] py-1 text-sm"
          onClick={onFaxesArchive}
        />
      </div>

      {assignPatientModalVisible && (
        <AssignPatientModal
          {...{
            assignPatientModalVisible,
            setAssignPatientModalVisible,
            faxQueryKey: 'inboundFaxes',
            faxes: selectedRows.map(({ data: fax }) => ({ id: fax?.id, files: fax?.files }))
          }}
        />
      )}

      {assignProvidersModalVisible && (
        <AssignProvidersModal
          {...{
            assignProvidersModalVisible,
            setAssignProvidersModalVisible,
            faxQueryKey: 'inboundFaxes',
            faxes: selectedRows.map(({ data: fax }) => ({ id: fax?.id, files: fax?.files }))
          }}
        />
      )}
    </>
  );
};

export default ButtonActions;
